import LoginViewContent from '@/admin/components/LoginViewContent/LoginViewContent';

const LoginPage = () => {
  return <></>;
  // return <LoginViewContent />;
};

export default LoginPage;
